var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"max-container",attrs:{"fluid":""}},[_c('CustomMenu'),_c('UsersComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }